export default import.meta.ROLLUP_FILE_URL_nYJf84yp5rLexz9ngcZBtw